// src/pages/meeting/InvitationEGM_ENPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import InvitationEGM2_ENForm from "../../forms/anounce/InvitationEGM2_EN/InvitationEGM2_EN";

function InvitationEGM2_ENPage() {
  return (
    <FormWrapper
      title="ประกาศเลิกบริษัทEnglishขั้นตอน2"
      FormComponent={InvitationEGM2_ENForm}
      formKey="InvitationEGM2_EN"
    />
  );
  }

export default InvitationEGM2_ENPage;
